import { LoginCredentials, RegisterCredentials } from '../types/auth';
import { API_URL, defaultOptions } from './config';

export async function login(credentials: LoginCredentials) {
    console.log('Attempting login with:', { ...credentials, password: '[REDACTED]' });
    console.log('API URL:', API_URL);
    console.log('Request options:', { ...defaultOptions, method: 'POST' });

    try {
        const response = await fetch(`${API_URL}/auth/login`, {
            ...defaultOptions,
            method: 'POST',
            body: JSON.stringify(credentials)
        });

        console.log('Response status:', response.status);
        console.log('Response headers:', Object.fromEntries(response.headers.entries()));

        if (!response.ok) {
            const error = await response.json();
            console.error('Login failed:', error);
            throw new Error(error.error || 'Failed to login');
        }

        const data = await response.json();
        console.log('Login successful');
        return data;
    } catch (error) {
        console.error('Login error:', error);
        throw error;
    }
}

export async function register(credentials: RegisterCredentials) {
    const response = await fetch(`${API_URL}/auth/register`, {
        ...defaultOptions,
        method: 'POST',
        body: JSON.stringify(credentials),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to register');
    }

    return response.json();
}


